/**
 * Component Registry for Repli Sandbox Avenue Theme
 *
 * Extends the base avenue theme registry with Repli Sandbox Avenue specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-avenue/registry';
import { Hero } from './components/Hero';

/**
 * Final merged registry for Repli Sandbox Avenue properties.
 * Inherits all components from the avenue theme, with company-specific overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  Hero,
};

export default registry;
